import * as SelectPrimitive from "@radix-ui/react-select";
import { ComponentProps } from "react";
import t from "@/lang/lang";
import {
  GSMServiceKind,
  ServiceKindList,
} from "@/services/backend/services/types/kinds";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";

// omniValue stands for the service kind "" of an omni process: a select
// item cannot have the empty string as its value.
const omniValue = "omni";

/**
 * ServiceKindSelect selects a service kind of availableServiceKinds. With
 * omni, it also offers the empty service kind of an omni process.
 */
export function ServiceKindSelect({
  availableServiceKinds = ServiceKindList,
  omni = false,
  value,
  onValueChange,
  ...props
}: ComponentProps<typeof SelectPrimitive.Root> & {
  availableServiceKinds?: GSMServiceKind[];
  omni?: boolean;
}) {
  return (
    <Select
      {...props}
      value={omni && value === "" ? omniValue : value}
      onValueChange={(v) => onValueChange?.(v === omniValue ? "" : v)}
    >
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Dienstleistung auswählen" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {omni && (
            <SelectItem value={omniValue}>
              {t("Omni (ohne Leistungsart)")}
            </SelectItem>
          )}
          {availableServiceKinds.map((serviceKind) => (
            <SelectItem value={serviceKind} key={serviceKind}>
              {serviceKind}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
